export default function DoctorsIntroPlaceholder(name, dateOfBirth, address, gender, analysisResults) {
  const genderAnamnesis = gender === 2 ? 'Urologická' : 'Gynekologická';
  const proband = gender === 2 ? 'Proband' : 'Probandka';
  return `<h2><strong>Souhrnná lékařská zpráva</strong></h2>
  <p>&nbsp;</p><p>&nbsp;</p>
  <p><strong>${proband}:</strong>&nbsp; &nbsp; ${name}</p>
  <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Datum narození: ${dateOfBirth}</p>
  <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; ${address}</p>
  <p>&nbsp;</p><hr><p>&nbsp;</p>
  <h4><strong><u>Anamnéza osobní:</u></strong></h4>
  <p>Věk v&nbsp;době vyšetření:</p>
  <p>Běžné dětské nemoci,</p>
  <p>Operace:</p>
  <p>Vážné úrazy:</p>
  <p><strong>Alergologická:&nbsp;</strong></p>
  <p>…&nbsp;</p>
  <p><strong>Farmakologická:&nbsp;</strong></p>
  <p>…&nbsp;</p>
  <p>&nbsp;<strong>Toxikologická:&nbsp;</strong></p>
  <p>…&nbsp;</p>
  <p><strong>Pracovní:&nbsp;</strong></p>
  <p>…&nbsp;</p>
  <p><strong>${genderAnamnesis}:&nbsp;</strong></p>
  <p>…&nbsp;</p>
  <p>&nbsp;</p>
  <h4><strong><u>Anamnéza rodinná - genealogie:&nbsp;</u></strong></h4>
  <p><i><strong>Matka:</strong></i></p>
  <p><i><strong>Otec:</strong></i></p>
  <p><i><strong>Sourozenci:</strong></i></p>
  <p><i><strong>Děti:</strong></i></p>
  <p>&nbsp;</p>
  <h4><strong><u>Genetické analýzy:</u></strong></h4>
  ${analysisResults}
  <p>&nbsp;</p>
  <h4><strong><u>Dodatečně sdělené informace z&nbsp;osobní a rodinné anamnézy:</u></strong></h4>
  <p><strong>…</strong></p>
  <p>&nbsp;</p>
  <h4><strong><u>Lékařský komentář k&nbsp;Vašim výsledkům:&nbsp;</u></strong></h4>
  <p>Na základě vyhodnocení Vaší genetické analýzy v&nbsp;souladu s&nbsp;dodanými informacemi* z Vaší
  osobní a rodinné anamnézy (čerpáno z&nbsp;dotazníku) pro Vás vyplývají následující doporučení:</p>
  <p>…&nbsp;</p>
  <p style="text-align:justify;">
  <i>*Rizika a doporučení by se mohla lišit, pokud by se u Vás nebo ve Vaší rodině vyskytovala
  závažná onemocnění, která nebyla v&nbsp;anamnéze uvedena a o kterých nemáme informace nebo se
  v&nbsp;budoucnu vyskytnou. V takovém případě doporučujeme genetickou konzultaci k&nbsp;doplnění
  a upřesnění informací pro přesnější stanovení rizika a vhodné dispenzarizace, popřípadě další
  genetické testování.</i>
  </p>
  <p style="text-align:justify;">
  <i>Přítomnost mutace, kterou nelze odhalit použitými metodami, případně mutace v jiném
  z predisponujících genů pro testovaná onemocnění nelze vyloučit. Výsledek příslušné genetické
  analýzy, kdy nebylo prokázáno riziko ve vyšetřovaných genech, proto nevylučuje možnost
  vzniku sledovaného onemocnění.</i>
  </p>
  <p style="text-align:justify;">
  <i>&nbsp;</i>
  </p>
  <p style="text-align:justify;">
  <strong>K&nbsp;upřesnění významu výsledků provedené analýzy doporučujeme objednat se
  ke genetické konzultaci na naše pracoviště.</strong>
  </p>
  <p>&nbsp;</p>`;
}
